// extracted by mini-css-extract-plugin
export default {"wrapper":"ir-z","viewport":"jr-z","container":"kr-z","slide":"lr-z"};